import Colors from '~global/Colors';

const carouselPaginationContainer = {
  width: '100%',
  position: 'absolute',
  bottom: 12,
  left: 0,
  zIndex: 9,
};
const carouselPagination = {
  height: 8,
  paddingVertical: 0,
};
const carouselDot = {
  backgroundColor: Colors.purple0,
  width: 8,
  height: 8,
};
const carouselDotInactive = {
  backgroundColor: Colors.grey0,
  width: 12,
  height: 12,
};

const carouselDotContainer = {
  marginHorizontal: 3,
};

const carouselSlide = {
  width: '100%',
  height: 185,
};

const carouselWrapper = {
  width: '100%',
  height: 185,
};

export {
  carouselDot,
  carouselDotContainer,
  carouselDotInactive,
  carouselPagination,
  carouselPaginationContainer,
  carouselSlide,
  carouselWrapper,
};
